"use strict";
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleSelect_SINGLE = exports.handleSelect_MULTI = void 0;
var handleSelect_MULTI = function (_a) {
    var parentOnChange = _a.parentOnChange, id = _a.id, prevVal = _a.prevVal, newVal = _a.newVal, 
    // hideShowOtherTextInputOnSelect_MULTI,
    saveValueAsString = _a.saveValueAsString;
    var shouldDeselect = prevVal && prevVal.some(function (d) { return d.value === newVal.value; }); //if value already exists in the selected array, then we should deselect
    var newValue = shouldDeselect
        ? prevVal.filter(function (d) { return d.value !== newVal.value; })
        : __spreadArray(__spreadArray([], (prevVal || []) /*prevVal*/, true), [newVal], false);
    // hideShowOtherTextInputOnSelect_MULTI({
    //   newVal: newValue,
    //   prevVal: prevVal,
    // });
    var newValForParent = saveValueAsString ? newValue.map(function (d) { return d.value; }) : newValue;
    parentOnChange && parentOnChange(id, newValForParent);
    // setForceSelectFocus && setForceSelectFocus(prev => prev+1)
};
exports.handleSelect_MULTI = handleSelect_MULTI;
var handleSelect_SINGLE = function (_a) {
    var parentOnChange = _a.parentOnChange, 
    // hideShowOtherTextInputOnSelect_SINGLE,
    handleHideOptions = _a.handleHideOptions, id = _a.id, newVal = _a.newVal, 
    // prevVal,
    saveValueAsString = _a.saveValueAsString;
    /**
     * this enables removing the selected option, if clicked on again
     * but disabled for now, cuz deselecting was causing all sorts of sideeffects on the platform
     */
    // let valueToSet = newVal?.value === prevVal?.value
    //   ? undefined
    //   : newVal
    var valueToSet = newVal;
    // hideShowOtherTextInputOnSelect_SINGLE({
    //     prevVal,
    //     newVal : valueToSet
    //   });
    parentOnChange &&
        parentOnChange(id, saveValueAsString ? valueToSet === null || valueToSet === void 0 ? void 0 : valueToSet.value : valueToSet);
    handleHideOptions();
};
exports.handleSelect_SINGLE = handleSelect_SINGLE;
